"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTouristsLabel = void 0;
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var getTouristsLabel = exports.getTouristsLabel = function getTouristsLabel(_ref) {
  var adultsValue = _ref.adultsValue,
    _ref$kidsValue = _ref.kidsValue,
    kidsValue = _ref$kidsValue === void 0 ? [] : _ref$kidsValue;
  var kidsCount = kidsValue.length;
  var touristsCount = adultsValue + kidsCount;
  var pluralize = kidsCount > 0 ? _pluralizeUtils.pluralizePerson : _pluralizeUtils.pluralizeAdults;
  return "".concat(touristsCount, " ").concat(pluralize(touristsCount));
};